// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"998f7b77","796":"58e47548"}[chunkId] + ".chunk.js";
};